import { Box, Grid, Typography, List, ListItem } from "@mui/material";
import { Link as ReactLink } from "react-router-dom";
import data from "./../../Assets/data/energysystems.json";
const ProjectsSection = () => {
  return (
    <>
      <Box
        style={{
          background: "#003366",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          // paddingTop: "2em",
          // paddingBottom: "2em",
        }}
      >
        <Box style={{ maxWidth: "960px", width: "100%" }}>
          <Grid container style={{ margin: "24px 0px" }}>
            <Grid item xs={12}>
              <Typography color="white" fontSize="28px" fontWeight={600}>
                PROJECTS
              </Typography>
            </Grid>
            {/* <Grid xs={12} item>
              <Typography color="white">
                Projects done or ongoing by Delina Research Group
              </Typography>
            </Grid> */}
            <Grid container>
              <Grid
                item
                xs={6}
                style={{
                  justifyContent: "flex-end",
                  display: "flex",
                  padding: "16px 0px",
                  boxSizing: "border-box",
                }}
              >
                <img
                  src={process.env.PUBLIC_URL + "/Images/project.jpg"}
                  alt="Projects"
                  style={{ width: "-webkit-fill-available" }}
                />
              </Grid>
              <Grid item xs={6}>
                <Box
                  sx={{
                    background: "white",
                    height: "100%",
                    padding: "16px",
                    boxSizing: "border-box",
                  }}
                >
                  <Typography fontWeight={600} fontSize="20px">
                    Energy Systems
                  </Typography>
                  <List>
                    {data.map((project, i) => {
                      return i < 5 ? (
                        <>
                          <ListItem
                            key={i}
                            style={{
                              marginLeft: "24px",
                              display: "flex",
                              justifyContent: "space-between",
                              width: "90%",
                            }}
                          >
                            <ReactLink
                              to={{ pathname: "/projects/" + project.url }}
                              style={{
                                textDecoration: "none",
                                color: "black",
                                cursor: "pointer",
                                fontSize: "16px",
                                padding: "6px",
                              }}
                            >
                              {project.title}
                            </ReactLink>
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "Images/Icons/ChevronRight.svg"
                              }
                              alt="Arrow"
                            />
                          </ListItem>
                          <Box
                            sx={{
                              height: "2px",
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Box
                              sx={{
                                height: "100%",
                                width: "90%",
                                background: "grey",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            />
                          </Box>
                        </>
                      ) : null;
                    })}
                  </List>
                </Box>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <ReactLink
                to={{ pathname: "/projects" }}
                style={{
                  textDecoration: "none",
                  color: "white",
                  cursor: "pointer",
                  fontSize: "18px",
                  padding: "12px",
                }}
              >
                See All Porjects
              </ReactLink>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default ProjectsSection;
